/* eslint-disable radix */
import React, { Component } from 'react';
import './detalhes.styles.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './detalhes.action';
import * as commonActions from '../../../app/common/common.action';
import { atributosMedicoDetalhes } from './detalhes.utils';
import { etapasIndexEnum } from '@common/util/defaultValues';
import DetalhesExamePage from './detalhes.page';
import { acessoPermitido } from '../../../acessos.seguranca';
class DetalhesExameContainer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      modalCancelados: false,
      carregandoMedicos: false,
      detalhesAberto: false,
      config: {},
      etapa: null,
      editorSize: () => {}
    };
  }

  verificaNotas () {
    const etapaNotas = document.getElementById('notas_etapa');
    if (etapaNotas) {
      document
        .getElementById('notas_etapa')
        .getElementsByTagName(
          'p'
        )[0].innerHTML = this.props.detalhes.nomeExibicaoEtapaNotas.toUpperCase();
    }
  }

  getConfig () {
    const config = {
      same: this.props.detalhes.exibirMatriculaSame
    };
    this.setState({ config });
  }

  abrirDetalhes () {
    var altura = this.props.altura;

    if (this.state.detalhesAberto) {
      altura -= 130;
    } else {
      altura += 130;
    }

    this.setState({ detalhesAberto: !this.state.detalhesAberto });
    this.props.commonActions.atualizarAltura(altura);
  }

  toggleModalCancelados () {
    this.setState(state => ({
      modalCancelados: !state.modalCancelados
    }));
  }

  getEtapa () {
    if (this.props.etapa && this.props.etapa.tab !== etapasIndexEnum.MATERIAL) {
      return ' (' + this.props.etapa.etapa + ')';
    }
    return '';
  }

  getDataConclusaoEtapa () {
    if (this.props.etapa.tab === etapasIndexEnum.MATERIAL) {
      return this.props.detalhes.dataEntradaMaterial;
    } else {
      const atributos = atributosMedicoDetalhes.find(
        a => a.id === this.props.etapa.tab
      );
      return this.props.detalhes[atributos.data];
    }
  }

  openMensagens () {
    this.props.commonActions.mudarStatusModalMensagem(
      true,
      this.props.detalhes.laudo
    );
  }

  ajustSizeEditor () {
    let time;
    this.setState({
      editorSize: setInterval(() => {
        time = !time ? 1000 : 20;
        const frame = document.getElementById('container-editor');
        let div = document.getElementById('container-editor-etapa');
        if (frame && div) {
          div = div.getBoundingClientRect();
          frame.style.top = `${div.top}px`;
          frame.style.left = `${div.left}px`;
          frame.style.height = `${window.innerHeight - div.top}px`;
          frame.style.width = `${div.width}px`;
        }
      }, time)
    });
  }

  componentWillUnmount () {
    clearInterval(this.state.editorSize);
  }

  componentDidMount () {
    this.getConfig();
    this.verificaNotas();
    if (!this.state.detalhesAberto) {
      var altura = this.props.altura;
      altura -= 140;
      this.props.commonActions.atualizarAltura(altura);
    }
  }

  UNSAFE_componentWillMount () {
    if (!this.state.detalhesAberto) {
      var altura = this.props.altura;
      altura += 140;
      this.props.commonActions.atualizarAltura(altura);
    }
  }

  UNSAFE_componentWillUpdate (nextProps, nextState) {
    if (nextProps.etapa.etapa !== nextState.etapa) {
      clearInterval(this.state.editorSize);

      this.ajustSizeEditor();
      this.setState({ etapa: nextProps.etapa.etapa, detalhesAberto: false });
    }
  }

  render () {
    return (
      <DetalhesExamePage
        acessoPermitido={acessoPermitido}
        //Propriedades
        usuario={this.props.usuario}
        detalhes={this.props.detalhes}
        etapa={this.props.etapa}
        exameFinalizado={this.props.exameFinalizado}
        exameEntregue={this.props.detalhes.entregue}
        // Estados
        config={this.state.config}
        modalCancelados={this.state.modalCancelados}
        detalhesAberto={this.state.detalhesAberto}
        // Métodos
        toggleModalCancelados={this.toggleModalCancelados.bind(this)}
        getDataConclusaoEtapa={this.getDataConclusaoEtapa.bind(this)}
        abrirDetalhes={this.abrirDetalhes.bind(this)}
        openMensagens={this.openMensagens.bind(this)}
        getEtapa={this.getEtapa.bind(this)}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    erratas: state.erratas,
    detalhes: state.commonReducer.detalhes,
    listagem: state.commonReducer.listagem,
    ordenacao: state.commonReducer.ordenacao,
    exameFinalizado: state.commonReducer.exameFinalizado,
    exameEntregue: state.commonReducer.exameEntregue,
    usuario: state.usuario
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetalhesExameContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/detalhes.container.js